import { useEffect, useRef, useState } from 'react';

const DEFAULT_QUERY_ELEMENT_RETRIES = 15;

interface Options {
  readonly queryElementRetries?: number;
}

interface UseRefByIdReturnType {
  readonly isElementFound: boolean;
  readonly ref: React.RefObject<HTMLElement>;
}

export const useRefById = (
  id?: string,
  { queryElementRetries = DEFAULT_QUERY_ELEMENT_RETRIES }: Options = {},
): UseRefByIdReturnType => {
  const ref = useRef<HTMLElement | null>(null);
  // we use state to force a re-render when the element is found
  const [isElementFound, setIsElementFound] = useState(false);

  useEffect(() => {
    if (id == null) return;

    let retries = queryElementRetries;

    const interval = setInterval(() => {
      const element = document.querySelector(`#${id}`);

      if (element == null) {
        retries -= 1;
        if (retries === 0) clearInterval(interval);

        return;
      }

      ref.current = element as HTMLElement;
      setIsElementFound(true);

      clearInterval(interval);
    }, 150);

    return () => {
      clearInterval(interval);
      setIsElementFound(false);
    };
  }, [id, queryElementRetries]);

  return { ref, isElementFound };
};
